import { FormattedMessage } from 'react-intl';
import { GroupedCashFlows } from '@algoan/dashboard/model';
import { useSelector } from '@algoan/dashboard/store/store';
import { CashFlowsTableStyle } from './style';
import { FormattedMoney } from '../atomic-components';
import {
  getCashFlowBeforeConsolidationForSpecificMonthOrLastCompleteMonth,
  getCashFlowBeforeConsolidationTotal,
} from '@algoan/dashboard/calculators';
import { checkedCashFlowsSelector } from '@algoan/dashboard/store/selectors';

export const CashFlowCalculationRow: React.FC<{ groupedCashFlows: GroupedCashFlows }> = ({ groupedCashFlows }) => {
  const checkedRows = useSelector(checkedCashFlowsSelector);

  return (
    <CashFlowsTableStyle.BodyHeader>
      <th>
        <FormattedMessage
          id="widgets.regular_cash_flows_analysis.cash_flow_calculation"
          defaultMessage="Cash flow calculation"
          description="Row label for cash flow calculation"
        />
      </th>
      <th />
      {groupedCashFlows.calendar.map((date, index) => {
        return (
          <th key={`category-rg-${index}`}>
            <FormattedMoney
              number={getCashFlowBeforeConsolidationForSpecificMonthOrLastCompleteMonth(
                groupedCashFlows,
                checkedRows,
                date.month,
              )}
            />
          </th>
        );
      })}
      <th>
        <FormattedMoney number={getCashFlowBeforeConsolidationTotal(groupedCashFlows, checkedRows)} />
      </th>
    </CashFlowsTableStyle.BodyHeader>
  );
};
